import dayjs from 'dayjs';

import { DB_DATE_FORMAT } from 'consts';

export const formatDB = (date?: dayjs.Dayjs) =>
  date && date.format(DB_DATE_FORMAT);
